"use strict";

function clickHamburgerMenu() {
  var htmlElement = document.getElementsByTagName("html")[0];
  htmlElement.classList.toggle("mobile-menu-open");
  var hamburger = document.querySelector(".sidenav");
  hamburger.classList.toggle("open");
  hamburger.classList.toggle("closed");
}

function closePanels() {
  var panes = document.querySelector(".panes");
  panes.classList.toggle("pane-0");
  panes.classList.toggle("pane-1");
}

function togglePanel(option) {
  var panes = document.querySelector(".panes");
  panes.classList.toggle("pane-0");
  panes.classList.toggle("pane-1");
  var expandoJobs = document.querySelector(".expando-jobs");
  var expandoNews = document.querySelector(".expando-news");
  var expandoResources = document.querySelector(".expando-resources");
  var expandoExperts = document.querySelector(".expando-experts");
  var expandoResume = document.querySelector(".expando-resume");

  switch (option) {
    case ".expando-jobs":
      expandoNews.classList.remove("visible-jobs");
      expandoResources.classList.remove("visible-jobs");
      expandoJobs.classList.add("visible-jobs");
      expandoExperts.classList.remove("visible-jobs");
      expandoResume.classList.remove("visible-jobs");
      break;

    case ".expando-news":
      expandoJobs.classList.remove("visible-jobs");
      expandoResources.classList.remove("visible-jobs");
      expandoNews.classList.add("visible-jobs");
      expandoExperts.classList.remove("visible-jobs");
      expandoResume.classList.remove("visible-jobs");
      break;

    case ".expando-resources":
      expandoJobs.classList.remove("visible-jobs");
      expandoNews.classList.remove("visible-jobs");
      expandoResources.classList.add("visible-jobs");
      expandoExperts.classList.remove("visible-jobs");
      expandoResume.classList.remove("visible-jobs");
      break;

    case ".expando-experts":
      expandoJobs.classList.remove("visible-jobs");
      expandoNews.classList.remove("visible-jobs");
      expandoResources.classList.remove("visible-jobs");
      expandoExperts.classList.add("visible-jobs");
      expandoResume.classList.remove("visible-jobs");
      break;

    case ".expando-resume":
      expandoJobs.classList.remove("visible-jobs");
      expandoNews.classList.remove("visible-jobs");
      expandoResources.classList.remove("visible-jobs");
      expandoExperts.classList.remove("visible-jobs");
      expandoResume.classList.add("visible-jobs");
      break;

    default:
      return;
  }
}

function toggleSection(sectionName) {
  var section = document.querySelector(sectionName);
  var sectionArrow = document.querySelector(sectionName + "-arrow");
  section.classList.toggle("open");
  sectionArrow.classList.toggle("open");
  sectionArrow.classList.toggle("closed");
}